import AA_JOURNEY_EVENT_MAPPING from './aaJourneyEvents';
export interface EventConfig {
  eventType: 'click' | 'screen';
  ctEvent: boolean;
  appsflyerEvent: boolean;
  appEventName?: string; // Optional alternate event name for sendToApp
}

export const JFS_EVENT_MAPPING: Record<string, EventConfig> = {
  WELCOME_SCREEN_VIEWED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  WELCOME_SCREEN_ASSET_BANK_LINK_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  WELCOME_SCREEN_ASSET_STOCKS_LINK_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  WELCOME_SCREEN_ASSET_MF_LINK_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  CONSENT_CREATION_INITIATED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  CONSENT_CREATION_SUCCESS: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: false,
  },
  CONSENT_CREATION_FAILED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  TOGGLE_AMOUNTS_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FAQ_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ASSET_BANK_LINK_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ASSET_STOCKS_LINK_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ASSET_MUTUAL_FUND_LINK_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ASSETS_DASHBOARD_VIEWED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: false,
  },
  BANK_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  STOCKS_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  MUTUAL_FUNDS_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  ADD_ASSET_DRAWER_VIEWED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: false,
  },
  ADD_ASSET_DRAWER_SAVINGS_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  ADD_ASSET_DRAWER_STOCKS_ETFS_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  ADD_ASSET_DRAWER_MUTUAL_FUNDS_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },

  DASHBOARD_CASHFLOW_TAB_CLICKED_OVERVIEW: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  DASHBOARD_CASHFLOW_TAB_CLICKED_MONEY_IN: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  DASHBOARD_CASHFLOW_TAB_CLICKED_MONEY_OUT: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  DASHBOARD_CASHFLOW_MONTH_PERIOD_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  
  MUTUAL_FUNDS_ASSET_LINKED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  STOCKS_ASSET_LINKED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  SAVINGS_ASSET_LINKED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  FIXED_DEPOSIT_ASSET_LINKED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  NPS_ASSET_LINKED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },

  ACCOUNTS_L1_GRAPH_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L1_CHEVRON_CLICKED_BANK: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  BACK_BUTTON_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L1_ADD_ACCOUNT_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L1_ALL_TRANSACTIONS_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACC_L1_CASHFLOW_TAB_CLICKED_OVERVIEW: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACC_L1_CASHFLOW_TAB_CLICKED_MONEYIN: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACC_L1_CASHFLOW_TAB_CLICKED_MONEYOUT: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACC_L1_CASHFLOW_MONTH_PERIOD_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L1_FAQ_MENU_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L1_REMOVE_ACCOUNT_MENU_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  BANK_REMOVE_ACCOUNT_CTA_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  BANK_KEEP_ACCOUNT_CTA_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  BANK_REMOVE_ACCOUNT_FAILURE: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  BANK_REMOVE_ACCOUNT_SUCCESS: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L2_GRAPH_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  CASHFLOW_TAB_MONTHS_SELECTION: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L2_VIEWED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L2_BACK_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L2_ALL_TRANSACTIONS_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L2_CATEGORY_ITEM_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACC_L2_CASHFLOW_TAB_CLICKED_OVERVIEW: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACC_L2_CASHFLOW_TAB_CLICKED_MONEYIN: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACC_L2_CASHFLOW_TAB_CLICKED_MONEYOUT: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },

  ALL_TRANSACTIONS_VIEWED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ALL_TRANSACTIONS_BACK_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ALL_TRANSACTIONS_FILTER_MODAL_OPENED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ALL_TRANSACTIONS_FILTER_APPLIED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ALL_TRANSACTIONS_FILTER_CLEARED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_VIEWED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: false,
  },
  STKS_ETFS_IFUND_DIST_INFO_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_SORT_OPENED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_FILTER_OPENED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_SORT_APPLIED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_FILTER_APPLIED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_FILTER_CLEAR_ALL_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_REMOVE_CTA_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_KEEP_CTA_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_REMOVE_SUCCESS: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_REMOVE_FAILURE: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_REMOVE_ACCOUNT_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_ETFS_HOLDING_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ETF_TOP_HOLDINGS_VIEW_ALL_BACK_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ETF_MARKET_CAP_DISTRIBUTION_INFO_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_FUNDAMENTALS_INFO_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_SORT_OPENED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_FILTER_OPENED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_SORT_APPLIED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_FILTER_APPLIED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_REMOVE_CTA_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_KEEP_CTA_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_REMOVE_SUCCESS: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MF_HOLDING_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_REMOVE_FAILURE: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MF_FUND_DISTRIBUTION_INFO_CLICKED_L1: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MF_FUND_DISTRIBUTION_INFO_CLICKED_L2: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  SECTOR_ALLOCATION_VIEW_ALL_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_REMOVE_ACCOUNT_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_L1_PAGE_VIEWED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  MFS_L2_PAGE_VIEWED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FAQ_VIEWED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },

  HOLDINGS_PAGE_BACK_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },

  VIEW_ALL_HOLDINGS_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  TOP_HOLDINGS_VIEW_ALL_BACK_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_L1_VIEWED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  STOCKS_L2_VIEWED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ETF_L2_VIEWED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ASSETS_DASHBOARD_INSIGHT_CARD_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },

  FIXED_DEPOSITS_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  ASSET_FIXED_DEPOSITS_LINK_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FD_SELECTED_BANK_CONTINUE_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  MANUAL_FD_SUBMISSION_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  MANUAL_FD_SUBMISSION_SUCCESS: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  MANUAL_FD_SUBMISSION_FAILED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  MANUAL_FD_DONE_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FD_ADD_MANUALLY_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  FD_L1_FAQ_MENU_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FD_REMOVE_ACCOUNT_MENU_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FD_REMOVE_ACCOUNT_SUCCESS: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FD_REMOVE_ACCOUNT_FAILURE: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FD_REMOVE_ACCOUNT_CTA_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FD_KEEP_ACCOUNT_CTA_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FD_REMOVE_ACCOUNT_TRY_AGAIN_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  FD_PROMO_BANNER_BOOK_NOW_CLICKED_GOLD: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  FD_PROMO_BANNER_BOOK_NOW_CLICKED_PURPLE: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  WELCOME_SCREEN_ASSET_FD_LINK_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  WELCOME_SCREEN_ASSET_NPS_LINK_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  ADD_ASSET_DRAWER_FD_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  ADD_ASSET_DRAWER_EXISTING_FD_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  ADD_ASSET_DRAWER_NPS_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  ADD_ASSET_DRAWER_EXISTING_NPS_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  ASSET_NPS_LINK_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ASSETS_DASHBOARD_NPS_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  NPS_L1_PAGE_VIEWED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_L2_PAGE_VIEWED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_TIER_TAB_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_TOGGLE_AMOUNTS_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_UNDERSTANDING_SECTION_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_REMOVE_ACCOUNT_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_REMOVE_CTA_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_KEEP_CTA_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_REMOVE_SUCCESS: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_REMOVE_FAILURE: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_REMOVE_TRY_AGAIN_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_FAQ_MENU_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_SORT_OPENED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_SORT_APPLIED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_FILTER_OPENED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NPS_FILTER_APPLIED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  AA_SELECTION_PROFILE_DISCOVERY_SUCCESS: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  AA_SELECTION_PROFILE_DISCOVERY_FAILURE: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  SELECTED_AA_Saafe: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  SELECTED_AA_Finvu: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  SELECTED_AA_NADL: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
};

export function getFAQEventConfig(eventCode: string): EventConfig | undefined {
  if (eventCode.startsWith('FAQ_CLICKED_') || eventCode === 'FAQ_CLICKED') {
    return {
      eventType: 'click',
      ctEvent: false,
      appsflyerEvent: false,
    };
  }
  if (eventCode.startsWith('MFS_FAQ_CLICKED')) {
    return {
      eventType: 'click',
      ctEvent: false,
      appsflyerEvent: false,
    };
  }
  return undefined;
}

export function getQuickFilterEventConfig(
  eventCode: string
): EventConfig | undefined {
  if (eventCode.startsWith('ALL_TXN_QUICK_FILTER_CLICKED_')) {
    return {
      eventType: 'click',
      ctEvent: false,
      appsflyerEvent: false,
    };
  }
  if (eventCode.startsWith('STOCKS_ETFS_QUICK_FILTER_CLICKED_')) {
    return {
      eventType: 'click',
      ctEvent: false,
      appsflyerEvent: false,
    };
  }
  return undefined;
}

export function getBankAccountEventConfig(
  eventCode: string
): EventConfig | undefined {
  if (eventCode.startsWith('ACCOUNTS_L1_ACCOUNT_CARD_CLICKED_BANK')) {
    return {
      eventType: 'click',
      ctEvent: false,
      appsflyerEvent: false,
    };
  }
  if (eventCode.startsWith('ACCOUNTS_L1_CATEGORY_ITEM_CLICKED_BANK')) {
    return {
      eventType: 'click',
      ctEvent: false,
      appsflyerEvent: false,
    };
  }
  return undefined;
}

export function getNudgeEventConfig(
  eventCode: string
): EventConfig | undefined {
  if (
    eventCode.startsWith('NUDGE_CTA_CLICK_') ||
    eventCode.startsWith('NUDGE_DASHBOARD_CLICKED_')
  ) {
    return {
      eventType: 'click',
      ctEvent: true,
      appsflyerEvent: false,
    };
  }
  if (eventCode.startsWith('NUDGE_')) {
    return {
      eventType: 'screen',
      ctEvent: true,
      appsflyerEvent: false,
    };
  }
  return undefined;
}

export function getForYouBannerEventConfig(
  eventCode: string
): EventConfig | undefined {
  if (eventCode.startsWith('BANNER_CLICKED_')) {
    return {
      eventType: 'click',
      ctEvent: true,
      appsflyerEvent: false,
    };
  }
  if (eventCode.startsWith('BANNER_')) {
    return {
      eventType: 'screen',
      ctEvent: true,
      appsflyerEvent: false,
    };
  }
  return undefined;
}

export function getEventConfig(eventCode: string): EventConfig | null {
  if (JFS_EVENT_MAPPING[eventCode]) {
    return JFS_EVENT_MAPPING[eventCode];
  }
  if (AA_JOURNEY_EVENT_MAPPING[eventCode]) {
    return AA_JOURNEY_EVENT_MAPPING[eventCode];
  }
  const faqConfig = getFAQEventConfig(eventCode);
  if (faqConfig) return faqConfig;

  const filterConfig = getQuickFilterEventConfig(eventCode);
  if (filterConfig) return filterConfig;

  const bankConfig = getBankAccountEventConfig(eventCode);
  if (bankConfig) return bankConfig;

  const nudgeConfig = getNudgeEventConfig(eventCode);
  if (nudgeConfig) return nudgeConfig;

  const forYouBannerConfig = getForYouBannerEventConfig(eventCode);
  if (forYouBannerConfig) return forYouBannerConfig;
  return null;
}
